export const works = [
  {
    id: 1,
    title: "WebStore",
    type: "Individual project",
    description: "An example of an online store selling any type of goods",
    stack: "React Redux Axios Persist",
    image: require("../ulits/images/works/webstore.jpg"),
    link: "https://lighthearted-crepe-659483.netlify.app/",
    git: "https://github.com/artyomakulov/myWebstore",
  },
  {
    id: 2,
    title: "Your pet",
    type: "Team project. Role: Team leader",
    description: "Mobile-first adaptive website for searching and selling pets",
    stack: "React Redux React-router Axios",
    image: require("../ulits/images/works/yourpet.jpg"),
    link: "https://artyomakulov.github.io/yourPet/",
    git: "https://github.com/artyomakulov/yourPet",
  },
  {
    id: 3,
    title: "Baza trainee",
    type: "Commercial team project",
    description:
      "Mobile-first adaptive website for Baza-Trainee that provides IT newcomers with real project experience to strengthen their skills. It also includes an admin panel for efficient project management",
    stack: "NextJS Axios Zustand ",
    image: require("../ulits/images/works/baza.png"),
    link: "https://baza-2-front-one.vercel.app/en",
    git: "https://github.com/baza-trainee/baza-2-front",
  },
  {
    id: 4,
    title: "Donate to UA army",
    type: "Volunteer team project",
    description:
      "Mobile-first adaptive landing for fundraising for the needs of the Ukrainian army",
    stack: "React",
    image: require("../ulits/images/works/zbir-na-avto.jpg"),
    link: "https://44-zbir.vercel.app/",
    git: "https://github.com/baza-trainee/44-zbir",
  },
  {
    id: 5,
    title: "Online Chat",
    type: "Individual project",
    description: "Real-time app for communication with friends or colleagues ",
    stack: "React Socket.io Node.js Express.js",
    image: require("../ulits/images/works/onlinechat.jpg"),
    link: "https://roaring-lolly-941e2f.netlify.app/",
    git: "https://github.com/artyomakulov/mySuperChat",
  },
  {
    id: 6,
    title: "Phonebook",
    type: "Individual project",
    description:
      "Phone book app with the ability to add, delete, filter and store contacts",
    stack: "React Redux React-router Axios",
    image: require("../ulits/images/works/phonebook.jpg"),
    link: "https://artyomakulov.github.io/goit-react-hw-08-phonebook/",
    git: "https://github.com/artyomakulov/goit-react-hw-08-phonebook/",
  },
  {
    id: 7,
    title: "Filmoteka",
    type: "Team project",
    description:
      "Mobile-first adaptive website for searching and previewing movies",
    stack: "JS HTML SASS Parcel",
    image: require("../ulits/images/works/filmoteka.jpg"),
    link: "https://oleksandrtymoshenko.github.io/js-project-10/",
    git: "https://github.com/artyomakulov/js-project-10",
  },
  {
    id: 8,
    title: "IceCream",
    type: "Team project",
    description:
      "Mobile-first adaptive landing page of the company, with adaptive layout",
    stack: "JS HTML SASS Parcel BEM-methodology",
    image: require("../ulits/images/works/icecream.jpg"),
    link: "https://artyomakulov.github.io/icecream-site/",
    git: "https://github.com/artyomakulov/js-project-10",
  },
  {
    id: 9,
    title: "Ecosolution",
    type: "Individual project",
    description:
      "Mobile-first adaptive landing page of the company, with adaptive layout",
    stack: "React Framer-motion",
    image: require("../ulits/images/works/ecosolution.jpg"),
    link: "https://ecosolution-dcvx.vercel.app/",
    git: "https://github.com/artyomakulov/ecosolution",
  },
];
